import { render, staticRenderFns } from "./ParametersJdDsList.vue?vue&type=template&id=729f6fe8&scoped=true"
import script from "./ParametersJdDsList.vue?vue&type=script&lang=js"
export * from "./ParametersJdDsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729f6fe8",
  null
  
)

export default component.exports